import { useQuery } from '@tanstack/react-query';
import { getFeatures } from '../services/featureService';

const getFeaturesReq = async () => {
  const { data } = await getFeatures();
  return data || [];
};

export const useFeatures = () => {
  return useQuery({
    queryKey: ['features'],
    queryFn: () => getFeaturesReq(),
    placeholderData: [],
    refetchOnWindowFocus: false,
    staleTime: 0,
  });
};
